import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Network, MapPin, Home } from 'lucide-react';

const Sitemap = () => {
    return (
        <>
            <Helmet>
                <title>Sitemap - ForeverUnion</title>
                <meta name="description" content="Sitemap of ForeverUnion. Find all the pages and matrimonial services available on our website." />
            </Helmet>

            <div className="bg-gray-50 min-h-screen py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
                        <div className="flex items-center gap-4 mb-8 border-b border-gray-100 pb-6">
                            <div className="bg-pink-100 p-3 rounded-full text-pink-600">
                                <Network className="w-8 h-8" />
                            </div>
                            <h1 className="text-3xl font-bold text-gray-900">Sitemap</h1>
                        </div>

                        <div className="grid md:grid-cols-2 gap-12">
                            <div>
                                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                                    <Home className="w-5 h-5 text-gray-400" />
                                    Main Pages
                                </h2>
                                <ul className="space-y-3">
                                    <li>
                                        <Link to="/" className="text-gray-600 hover:text-pink-600 hover:underline transition-colors block py-1">
                                            Home
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/about" className="text-gray-600 hover:text-pink-600 hover:underline transition-colors block py-1">
                                            About Us
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/contact" className="text-gray-600 hover:text-pink-600 hover:underline transition-colors block py-1">
                                            Contact Us
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/login" className="text-gray-600 hover:text-pink-600 hover:underline transition-colors block py-1">
                                            Login / Register
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                                    <MapPin className="w-5 h-5 text-gray-400" />
                                    Regional Matrimony
                                </h2>
                                <ul className="space-y-3">
                                    <li>
                                        <Link to="/delhi-matrimony" className="text-gray-600 hover:text-pink-600 hover:underline transition-colors block py-1">
                                            Delhi Matrimony
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/mumbai-matrimony" className="text-gray-600 hover:text-pink-600 hover:underline transition-colors block py-1">
                                            Mumbai Matrimony
                                        </Link>
                                    </li>
                                    {/* Future placeholders */}
                                    <li>
                                        <span className="text-gray-400 cursor-not-allowed">Bangalore Matrimony (Coming Soon)</span>
                                    </li>
                                    <li>
                                        <span className="text-gray-400 cursor-not-allowed">Chennai Matrimony (Coming Soon)</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sitemap;
